import {$,w} from './constants';

// Set data-rate order for each table row
var rates = []
$('.td_rate_val_JS').each(function () {
	rates.push(parseFloat($(this).text(),10))
})
rates.sort((a, b) => a - b).reverse()
var count = 0 
rates.forEach(function (rate) {
	count++
	$('.td_rate_val_JS:contains("'+rate+'")').closest('.table_row_JS').attr('data-rate',count)
})

// Sort table rows by rates
var sortStatus = 0
$('.table_sort_JS').click(function () {
	$(this).addClass('active')

	if (sortStatus == 0) {
		// Sort rows greater to smaller
		$(this).addClass('desc').removeClass('asc')
		var tableRows = $('.table_row_JS')
		tableRows.sort(function(a,b) {
			var rateA = $(a).data('rate')
			var rateB = $(b).data('rate')

			if (rateA === undefined) return 1
			if (rateB === undefined) return -1

			return rateA - rateB
		})
		$('.table_body_JS').html(tableRows)
		sortStatus = 1
	} else {
		// Sort rows smaller to greater
		$(this).addClass('asc').removeClass('desc')
		var tableRows = $('.table_row_JS')
		tableRows.sort(function(a,b) {
			var rateA = $(a).data('rate')
			var rateB = $(b).data('rate')

			if (rateA === undefined) return 1
			if (rateB === undefined) return -1

			return rateB - rateA
		})
		$('.table_body_JS').html(tableRows)
		sortStatus = 0
	}
})

if ($('.auto_sort_JS').length) {
	$('.table_sort_JS').click()
}	
